import { createSelector } from 'reselect';

const rootCausesStore = (store) => store.apps.builds.rootCauses;
export const userStore = (store) => store.user;
export const vdcBuildStore = (store) => store.apps.builds.vdc;

export const buildUserSelector = createSelector([
  vdcBuildStore,
  userStore,
],
(builds, user) => {
  const buildParams = {
    build_name: builds.getIn(['build', 'name']),
    org_id: builds.getIn(['build', 'org_id']),
  };

  const isBuildOwner = builds.getIn(['build', 'owner']) === user.get('username');
  const isTeamMember = user.get('teams').some(({ id }) => (
    id === builds.getIn(['build', 'team_id'])
  ));

  if (isBuildOwner) {
    return {
      ...buildParams,
      user_id: user.get('user_id'),
    };
  }

  if (isTeamMember) {
    return {
      ...buildParams,
      team_id: builds.getIn(['build', 'team_id']),
    };
  }

  return buildParams;
});

export const buildRootCausesSelector = createSelector(
  rootCausesStore,
  (rootCauses) => ({
    loadingData: rootCauses.get('loadingData'),
    items: rootCauses.get('items'),
  }),
);

export const rootCauseDataSelector = createSelector([
  rootCausesStore,
  (store, options) => options,
], (rootCauses, options) => rootCauses.getIn(['items', options.patternId]));

export const rootCauseAdditionalDataSelector = createSelector([
  rootCausesStore,
  (store, options) => options,
], (rootCauses, options) => {
  const rootCauseItem = rootCauses.getIn(['items', options.patternId]);

  if (!rootCauseItem) {
    return {
      isDataExists: false,
    };
  }

  const annotations = rootCauseItem.getIn(['annotations', 'data']);
  const jobs = rootCauseItem.getIn(['jobs', 'data']);
  return {
    isDataExists: !!(annotations?.length && jobs?.length),
  };
});
